import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PnrFlightFormComponent } from 'app/components/pnr-flight-form/pnr-flight-form.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { PassengerDigitalTwinComponent } from 'app/components/passenger-digital-twin/passenger-digital-twin.component';
import { OrientationPopupComponent } from 'app/components/passenger-digital-twin/orientation-popup/orientation-popup.component';
import { PassengerVideoViewComponent } from 'app/components/passenger-digital-twin/passenger-video-view/passenger-video-view.component';
import { WebRtcService } from 'app/services/web-rtc.service';
import { HttpClientModule } from '@angular/common/http';
import { ApiService } from 'app/services/api.service';
import { SocketService } from 'app/services/socket.service';
import { PaxGuardGuard } from 'app/pax-guard.guard';
import { AllGatesComponent } from 'app/components/all-gates/all-gates.component';
import { AppComponent } from 'app/app.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { DynamicgateComponent } from 'app/components/dynamicgate/dynamicgate.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CheckandfacilitiesComponent } from 'app/components/checkandfacilities/checkandfacilities.component';
import { CookieService } from 'ngx-cookie-service'
import { AdvertaisementComponent } from 'app/components/advertaisement/advertaisement.component';

const appRoutes: Routes = [
  { path: '', component: PnrFlightFormComponent, pathMatch: 'full' },
  { path: 'bahome', component: PnrFlightFormComponent, pathMatch: 'full' },
  // { path: 'pax', component: PassengerDigitalTwinComponent, pathMatch: 'full', canActivate: [PaxGuardGuard] },
  { path: 'pax', component: PassengerDigitalTwinComponent, pathMatch: 'full'},
  {path:'gates', component: AllGatesComponent, pathMatch:'full'},
  {path:'services', component: CheckandfacilitiesComponent, pathMatch:'full'},
  // {path:'random', component:DynamicgateComponent, pathMatch:'full'},
  { path: '**', redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    PnrFlightFormComponent,
    PassengerDigitalTwinComponent,
    OrientationPopupComponent,
    PassengerVideoViewComponent,
    CheckandfacilitiesComponent,
    AdvertaisementComponent
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    SwiperModule,
    NgbModule,
    MatProgressBarModule,
    // MatDialogModule
  ],
  providers: [
    WebRtcService,
    ApiService,
    SocketService,
    CookieService
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
